import React, {useMemo} from 'react';
import {MRAppRoutes} from '../../../../router/routes';
import {useLocation, useNavigate} from 'react-router-dom';
import {Tabs} from 'antd';
import type {TabsProps} from 'antd';
import {tid} from '../../../../../testUtils';
import styles from './AdminNavBar.module.scss';

const tabLinks: [string, MRAppRoutes][] = [
  ['Manage Metadata', MRAppRoutes.MANAGE_METADATA],
  ['Internal Users', MRAppRoutes.USER_LIST],
  ['Incident Management', MRAppRoutes.INCIDENT_MANAGEMENT],
  ['External Users', MRAppRoutes.ADMIN_EXTERNALIZATION_LIST],
];

const AdminNavBar: React.FC = () => {
  const {pathname} = useLocation();
  const navigate = useNavigate();

  const activeTabKey = useMemo(() => {
    const foundIndex = tabLinks.findIndex((tabLink) => pathname.startsWith(tabLink[1]));
    return foundIndex >= 0 ? String(foundIndex) : '0';
  }, [pathname]);

  const tabItems: TabsProps['items'] = tabLinks.map(([label], index) => ({
    key: String(index),
    label,
    children: null,
  }));

  const handleTabChange = (key: string) => {
    const route = tabLinks[parseInt(key, 10)][1];
    navigate(route);
  };

  return (
    <div className={styles.navShell}>
      <Tabs
        activeKey={activeTabKey}
        onChange={handleTabChange}
        items={tabItems}
        type="card"
        className={styles.adminTabs}
        {...tid('admin-navbar-tabs')}
      />
    </div>
  );
};

export default AdminNavBar;
